<template>
  <div
    :style="'position: relative; overflow:scroll; height:' +
      (typeof height == 'string' ? height : height + 'px')
    "
    class="fill islide"
    :class="`islide_${slides.join()}`"
  >
    <div class="flex align-end" :style="`width:100%; position: fixed;`">
      <i
        :class="x - 1 === slide ? 'success-text' : ''"
        @click="slide = x - 1"
        v-for="x in slides.length"
        :key="x"
        class="m4 fa-xs fa fa-dot-circle"
      />
    </div>
    <div class="fill" v-for="(page, pagei) in slides" :key="pagei">
      <transition name="fade"
        ><ipage
          style="overflow: scroll"
          class="fill"
          v-if="slide === pagei"
          :pagetitle="page"
      /></transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slide: 0,
    };
  },
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    interval: {
      type: Number,
      default: 10000,
    },
    height: { type: [Number, String], default: 400 },
  },
  mounted() {
    setInterval(() => {
      this.slide = this.slide + 1 === this.slides.length ? 0 : this.slide + 1;
    }, this.interval);
  },
};
</script>

<style>
</style>